/*
 * Where Pixally launches first, and what to do about everyone else.
 *
 * The backend keeps its own copy of this list for reporting. The two are
 * deliberately NOT wired together: this one decides which form a visitor is
 * shown, and the server's decides nothing at all, because the country arrives
 * in a forgeable header. Neither is allowed to depend on the other being right.
 */

// ISO-3166 alpha-2. GB, not UK: UK is not the ISO code and the edge sends GB.
export const LAUNCH_TERRITORIES = ['US', 'CA', 'GB'];

// Where the waitlist game (points, rewards, the Founding 50, the prize draw) runs: the US only, as the
// Official Rules say (section 4; Ryan, 2026-10-19). Narrower than LAUNCH_TERRITORIES, which says where
// Pixally itself opens (and which currencies the pricing shows): Canada and the UK get the email list.
export const WAITLIST_TERRITORIES = ['US'];

export const INTERNATIONAL_PATH = '/international';

/**
 * True only when we KNOW the visitor is outside the launch territories.
 *
 * Unknown is treated as inside, on purpose. Failing this open means a visitor
 * whose country we could not read still sees the normal signup, which is the
 * cheaper mistake: showing the main form to someone abroad costs them one click
 * on the "I'm outside these countries" link, while hiding it from someone in
 * Ohio because an edge lookup came back empty costs a real signup.
 */
export const isOutsideLaunchTerritories = (country) =>
  Boolean(country) && !LAUNCH_TERRITORIES.includes(String(country).toUpperCase());

/** True only when we KNOW the visitor is outside the waitlist's countries (unknown fails open, as above). */
export const isOutsideWaitlistTerritories = (country) =>
  Boolean(country) && !WAITLIST_TERRITORIES.includes(String(country).toUpperCase());
